export const Tracker = () => {
    if (!window.gtag){ 
      console.error('GTAG UNKNOWN');
      return 
    } ;
    window.gtag('config', 'UA-62292377-2', { page_path: window.location.pathname })
}

export default Tracker;